import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconFilter1"><Path d="M3.75 3C3.33579 3 3 3.33579 3 3.75V8C3 8.19891 3.07902 8.38968 3.21967 8.53033L9 14.3107V21.25C9 21.4844 9.10956 21.7053 9.29615 21.8471C9.48275 21.9889 9.72491 22.0354 9.95073 21.9726L14.4507 20.7226C14.7753 20.6325 15 20.3369 15 20V14.3107L20.7803 8.53033C20.921 8.38968 21 8.19891 21 8V3.75C21 3.33579 20.6642 3 20.25 3H3.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter1;
